(() => {
  const dropdowns = [...document.querySelectorAll('[data-consumer-dropdown]')];
  dropdowns.forEach((dropdown) => {
    const row = dropdown.closest('.consumer-nav__row');
    const trigger = row.querySelector(':scope > a');
    const desktop = Boolean(row.closest('.site-nav'));
    const open = () => {
      dropdowns.forEach((other) => { if (other !== dropdown) other.open = false; });
      dropdown.open = true;
      trigger.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      dropdown.open = false;
      trigger.setAttribute('aria-expanded', 'false');
    };
    row.addEventListener('mouseenter', () => { if (desktop) open(); });
    row.addEventListener('mouseleave', () => { if (desktop && !row.contains(document.activeElement)) close(); });
    row.addEventListener('focusin', () => { if (desktop) open(); });
    row.addEventListener('click', (event) => {
      if (event.target.closest('a') === trigger && !desktop && !dropdown.open) {
        event.preventDefault();
        event.stopPropagation();
        open();
      }
    }, true);
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === ' ') {
        event.preventDefault();
        open();
        dropdown.querySelector('a')?.focus();
      }
    });
    dropdown.addEventListener('toggle', () => {
      trigger.setAttribute('aria-expanded', String(dropdown.open));
    });
    row.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && dropdown.open) {
        event.preventDefault();
        event.stopPropagation();
        trigger.focus();
        close();
      }
    });
    row.addEventListener('focusout', (event) => {
      if (event.relatedTarget && !row.contains(event.relatedTarget)) close();
    });
    dropdown.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { dropdown.open = false; }));
  });
  document.addEventListener('click', (event) => {
    dropdowns.forEach((dropdown) => { if (!dropdown.closest('.consumer-nav__row').contains(event.target)) dropdown.open = false; });
  });
  const openAnswer = () => {
    const answer = document.getElementById(location.hash.slice(1));
    if (answer?.matches('.serenova-faq details')) {
      answer.open = true;
      answer.querySelector('summary').focus({ preventScroll: true });
      answer.scrollIntoView({ block: 'start' });
    }
  };
  openAnswer();
  window.addEventListener('hashchange', openAnswer);
})();
